import { render, staticRenderFns } from "./TableHistory.vue?vue&type=template&id=2060ed97&scoped=true"
import script from "./TableHistory.vue?vue&type=script&lang=js"
export * from "./TableHistory.vue?vue&type=script&lang=js"
import style0 from "./TableHistory.vue?vue&type=style&index=0&id=2060ed97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060ed97",
  null
  
)

export default component.exports